const LAST_PATH_KEY = 'topicCenterLastPathname';
const PREV_PATH_KEY = 'topicCenterPreviousPath';

const TOPIC_CENTER_PATH_RE = /\/topics\/[^/]+\/?$/;

// Allowed values for topicSource (product/analytics)
const TOPIC_SOURCE_VALUES = [
  'menu',
  'allTopics',
  'search',
  'resources',
  'assessmentResults',
  'favourites',
  'homePage',
  'topicPage',
  'resourcePage',
  'history',
];

function inferSourceFromPath(prevPath) {
  if (!prevPath || typeof prevPath !== 'string') return null;
  const path = prevPath.split('?')[0].replace(/\/$/, '');
  const pathNorm = path.replace(/^\/[^/]+/, '') || path;
  if (pathNorm === '/topics' || path === '/topics') return 'allTopics';
  if (pathNorm === '/' || pathNorm === '' || path === '/' || path === '')
    return 'homePage';
  if (
    path.includes('favorites') ||
    pathNorm.startsWith('/favorites') ||
    path.startsWith('/favorites')
  )
    return 'favourites';
  if (pathNorm === '/resources' || path === '/resources') return 'resources';
  if (
    pathNorm.startsWith('/resource/') ||
    path.startsWith('/resource/') ||
    pathNorm.startsWith('/article/') ||
    path.startsWith('/article/')
  )
    return 'resourcePage';
  if (
    path.includes('assessments') ||
    pathNorm.startsWith('/assessments') ||
    path.startsWith('/assessments')
  )
    return 'assessmentResults';
  if (
    path.includes('account/history') ||
    pathNorm.startsWith('/account/history') ||
    path.startsWith('/account/history')
  )
    return 'history';
  if (
    pathNorm.startsWith('/bestlists') ||
    path.startsWith('/bestlists') ||
    path.startsWith('/bestlists/')
  )
    return 'topicPage';
  if (pathNorm.startsWith('/topics/') || path.startsWith('/topics/'))
    return 'topicPage';
  if (
    pathNorm.startsWith('/series') ||
    pathNorm.startsWith('/learning-lab') ||
    path.startsWith('/series') ||
    path.startsWith('/learning-lab')
  )
    return 'topicPage';
  return 'topicPage';
}

export function onRouteChange(pathname) {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    const path = (pathname || '').split('?')[0];
    const isTopicCenter = TOPIC_CENTER_PATH_RE.test(path);
    const last = window.sessionStorage.getItem(LAST_PATH_KEY);
    const lastWasTopicCenter = last && TOPIC_CENTER_PATH_RE.test(last);
    if (isTopicCenter && last && !lastWasTopicCenter) {
      window.sessionStorage.setItem(PREV_PATH_KEY, last);
    }
    window.sessionStorage.setItem(LAST_PATH_KEY, path);
  } catch (e) {
    // ignore
  }
}

export function normalizeTopicSource(value) {
  if (!value) return null;
  if (TOPIC_SOURCE_VALUES.includes(value)) return value;
  const map = {
    'all-topics-page': 'allTopics',
    'assessment-results': 'assessmentResults',
    favorites: 'favourites',
    'homepage-card': 'homePage',
    'homepage-trending-topics': 'homePage',
    'guide-me': 'homePage',
    'topic-center': 'topicPage',
    'topic-center-explore-more': 'topicPage',
    'best-lists': 'topicPage',
    'related-topics': 'topicPage',
    'topic-card': 'topicPage',
    'resource-page': 'resourcePage',
  };
  return map[value] || 'topicPage';
}

function getAndClearTopicCenterPreviousPath() {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return null;
    const value = window.sessionStorage.getItem(PREV_PATH_KEY);
    window.sessionStorage.removeItem(PREV_PATH_KEY);
    return value;
  } catch (e) {
    return null;
  }
}

/** Returns topicSource from previous path (fallback when location.state is not passed) */
export function getTopicCenterSourceWithFallback() {
  const prevPath = getAndClearTopicCenterPreviousPath();
  return inferSourceFromPath(prevPath);
}
